<div class="content-box">
  <h2 class="header-major">Almost Finished...</h2>
  <p>We need to confirm your email address.</p>
  <p>To complete the subscription process, please click the link in the email we just sent you.</p>
</div>
